const overseasPartnerRouter = {
  route: null,
  name: null,
  title: '出海合作单位',
  type: 'folder',
  icon: 'iconfont el-icon-office-building',
  filePath: 'view/overseas_partner/',
  order: 5,
  inNav: true,
  permission: ['查询合作单位分类', '查询合作单位'],
  children: [
    {
      title: '合作单位分类',
      type: 'view',
      name: 'overseasPartnerCategoryList',
      route: '/overseas-partner-category/list',
      filePath: 'view/overseas_partner/category-list.vue',
      inNav: true,
      icon: 'iconfont el-icon-menu',
      permission: ['查询合作单位分类'],
    },
    {
      title: '合作单位管理',
      type: 'view',
      name: 'overseasPartnerUnitList',
      route: '/overseas-partner-unit/list',
      filePath: 'view/overseas_partner/unit-list.vue',
      inNav: true,
      icon: 'iconfont el-icon-office-building',
      permission: ['查询合作单位'],
    },
  ],
}

export default overseasPartnerRouter
